module.exports = __webpack_public_path__ + "static/Gynecology-2e8a92fec2784fac7b6c5503647aefdc.png";